export default "__VITE_ASSET__ChhHVIGR__"